import { Component, Input, OnInit } from "@angular/core";
import { NgbModal, NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { ActivatedRoute, Params, Router } from "@angular/router";
import {
  FormArray,
  FormBuilder,
  FormGroup,
  Validators,
  SelectMultipleControlValueAccessor,
} from "@angular/forms";
import { first } from "rxjs/operators";
import { Departement } from "../../core/model/departement";
import { Direction } from "../../core/model/direction";
import { DirectionService } from "../../core/service/direction.service";
import { DepartementService } from "../../core/service/departement.service";

@Component({
  selector: "app-add-departement",
  templateUrl: "./add-departement.component.html",
  styleUrls: ["./add-departement.component.scss"],
})
export class AddDepartementComponent implements OnInit {
  departement: Departement = new Departement();
  directions: Direction[];

  form2: FormGroup;
  pressButton: Boolean = false;

  constructor(
    private _router: Router,
    private _activatedRoute: ActivatedRoute,
    private _directionService: DirectionService,
    private _departementService: DepartementService,
    private fb: FormBuilder,
    public activeModal: NgbActiveModal) {
    this.createForm();
  }

  createForm() {
    this.form2 = this.fb.group({
      active: [null, Validators.compose([Validators.required])],
      code: [null, Validators.compose([Validators.required])],
      label: [null, Validators.compose([Validators.required])],
      direction: [null, Validators.compose([Validators.required])],
    });
  }

  ngOnInit() {
    this.getDirections();
  }

  getDirections() {
    this._directionService.getAllDirections().subscribe(
      (data) => {
        this.directions = data;
      },
      (error) => {
        console.log(error);
      }
    );
  }

  save(): void {
    this.pressButton = true;
    this._departementService
      .postDepartement(this.departement)
      .pipe(first())
      .subscribe(
        (data) => {
          this.pressButton = false;
          this.activeModal.close();
        },
        (error) => {
          console.log(error);
          this.pressButton = false;
        }
      );
  }
}
